import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { ApplicationState } from 'store/redux';
import { IAuthenticationActionCreators, LoginState, UserState } from 'store/redux/Authentication';
import * as AuthenticationStore from 'store/redux/Authentication';
import Context from 'configuration/context';
import { authenticationServiceFactory } from 'services/authenticationService';

export type IAccessTokenProviderProps = PropsWithChildren<
  IAuthenticationActionCreators & {
    authenticationState?: UserState;
  }
>;

const AccessTokenProvider: FC<IAccessTokenProviderProps> = (props: IAccessTokenProviderProps) => {
  const [accessTokenIsValid, setAccessTokenIsValid] = useState(false);

  const { authenticationState, setLoginState } = props;

  useEffect(() => {
    if (
      authenticationState?.LoginState === AuthenticationStore.LoginState.LOGGED_IN &&
      !!setLoginState
    ) {
      authenticationServiceFactory(Context.APIUrl, { setLoginState }, authenticationState)
        .getOrRenewNativeToken()
        .then(() => {
          setAccessTokenIsValid(true);
        });
    }
  }, [LoginState, authenticationState]);

  return <React.Fragment>{accessTokenIsValid && props.children}</React.Fragment>;
};

export default connect(
  (appState: ApplicationState) => ({ authenticationState: appState.authentication }),
  { ...AuthenticationStore.actions }
)(AccessTokenProvider);
